// src/utils/statusDefinitions.js

export const STATUS_LEVELS = {
  // DEFAULT - Healthy state (no color change)
  'healthy': {
    color: null,
    priority: 0,
    description: 'All systems operational',
    icon: '✓',
    isHealthy: true
  },
  'healthy-pending': {
    color: null,
    priority: 1,
    description: 'Healthy with pending data to sync',
    icon: '⟳',
    isHealthy: true
  },

  // YELLOW SPECTRUM - Warning states
  'sync-delayed': {
    color: '#FCD34D',
    priority: 2,
    description: 'Sync delayed but will retry',
    icon: '⚠',
    isHealthy: false
  },
  'partial-sync': {
    color: '#FBBF24',
    priority: 3,
    description: 'Some records failed to sync',
    icon: '◐',
    isHealthy: false
  },
  'high-backlog': {
    color: '#F59E0B',
    priority: 4,
    description: 'Large number of unsynced records',
    icon: '▲',
    isHealthy: false
  },

  // GREY SPECTRUM - Network/connectivity issues
  'offline': {
    color: '#9CA3AF',
    priority: 5,
    description: 'No internet connection',
    icon: '✗',
    isHealthy: false
  },
  'slow-connection': {
    color: '#6B7280',
    priority: 6,
    description: 'Slow network detected',
    icon: '⚡',
    isHealthy: false
  },

  // ORANGE SPECTRUM - Database issues
  'rds-timeout': {
    color: '#FB923C',
    priority: 7,
    description: 'Database connection timeout',
    icon: '⏱',
    isHealthy: false
  },
  'rds-error': {
    color: '#F97316',
    priority: 8,
    description: 'Database connection error',
    icon: '⚠',
    isHealthy: false
  },

  // RED SPECTRUM - Server errors
  'backend-unreachable': {
    color: '#EF4444',
    priority: 9,
    description: 'Backend server unreachable',
    icon: '⊗',
    isHealthy: false
  },
  'backend-down': {
    color: '#DC2626',
    priority: 10,
    description: 'Backend server not running',
    icon: '■',
    isHealthy: false
  },
  'backend-5xx': {
    color: '#EF4444',
    priority: 11,
    description: 'Server error (500-599)',
    icon: '⊗',
    isHealthy: false
  },
  'backend-timeout': {
    color: '#DC2626',
    priority: 12,
    description: 'Backend API timeout',
    icon: '⏲',
    isHealthy: false
  },
  'backend-overload': {
    color: '#B91C1C',
    priority: 13,
    description: 'Server overloaded (503)',
    icon: '▓',
    isHealthy: false
  },

  // PURPLE SPECTRUM - Client/data errors
  'client-4xx': {
    color: '#A855F7',
    priority: 14,
    description: 'Client error (400-499)',
    icon: '!',
    isHealthy: false
  },
  'auth-error': {
    color: '#9333EA',
    priority: 15,
    description: 'Authentication failed (401/403)',
    icon: '🔒',
    isHealthy: false
  },
  'data-validation-error': {
    color: '#7C3AED',
    priority: 16,
    description: 'Data validation failed',
    icon: '✎',
    isHealthy: false
  },

  // BROWN SPECTRUM - Data integrity issues
  'indexeddb-error': {
    color: '#92400E',
    priority: 17,
    description: 'Local database error',
    icon: '⚠',
    isHealthy: false
  },
  'storage-full': {
    color: '#78350F',
    priority: 18,
    description: 'Local storage nearly full',
    icon: '▓',
    isHealthy: false
  },

  // BLACK SPECTRUM - Critical failures
  'critical-error': {
    color: '#1F2937',
    priority: 19,
    description: 'Critical system error',
    icon: '⊗',
    isHealthy: false
  },
  'max-retries-exceeded': {
  color: '#111827',
  priority: 20,
  description: 'Max retry attempts exceeded', // This will be overridden in display
  icon: '⊠',
  isHealthy: false,
  getDynamicDescription: (metrics) => {
    if (metrics?.lastErrorType) {
      const underlying = STATUS_LEVELS[metrics.lastErrorType];
      return `Max retries: ${underlying?.description || 'Connection failed'}`;
    }
    return 'Max retry attempts exceeded';
  }
},
  'sync-stopped': {
    color: '#000000',
    priority: 21,
    description: 'Sync process stopped',
    icon: '■',
    isHealthy: false
  }
};